import {Backdrop, CircularProgress, FormControl, MenuItem, Select} from "@mui/material";
import {useEffect, useState} from "react";
import {currentTab, updateTab} from "../../features/tab/tabSlice";
import {useDispatch, useSelector} from 'react-redux';
import {Calendar, DateObject} from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import persian_en from "react-date-object/locales/persian_en"
import weekends from "react-multi-date-picker/plugins/highlight_weekends"
import {
    getSubRequestGroup,
    getReservedDays,
    getReservedTimes,
    getReservedSubTimes,
    addReservedSubTimes,
    getRequestGroup
} from '../../api/routes';
import moment from 'jalali-moment'
import {toast} from 'react-toastify';
import setToSession from "./setToSession";
import getMinutes from './getMinutes';
import plusTimes from "./plusTimes";
import useQueryParams from "./useQueryParams";
import {useNavigate} from "react-router-dom";

const PickDate = () => {
    const m = moment();
    const navigate = useNavigate()
    const [selectedDay, setSelectedDay] = useState(new DateObject());
    const [requestGroupData, setRequestGroupData] = useState([]);
    const [subRequestGroupData, setSubRequestGroupData] = useState([]);
    const [reservedDays, setReservedDays] = useState([])
    const [loading, setLoading] = useState(false)
    const [currentTime, setCurrentTime] = useState();
    const [service, setService] = useState('');
    const [subService, setSubService] = useState('');
    const [openSubService, setOpenSubService] = useState(false);
    const [selectedMonth, setSelectedMonth] = useState(m?.locale('fa')?.format('MM'));
    const [selectedYear, setSelectedYear] = useState(m?.locale('fa')?.format('YYYY'));
    const [reservedTimes, setReservedTimes] = useState([])
    const [reservedSubTimes, setReservedSubTimes] = useState([])
    const [clickedSubTime, setClickedSubTime] = useState('')
    const [onChanging, setOnChanging] = useState(false);
    const dispatch = useDispatch();
    const [hideService, setHideService] = useState(false);

    let subTimes = reservedSubTimes.map((item) => item.subTime)
    const {code, ref} = useQueryParams()
    useEffect(() => {
        if (code && ref === 'afterPayment') {
            dispatch(updateTab(5))
        }
    }, [code, ref])
    const handleChange = (event) => {
        setService(event.target.value);
        if (event.target.value === 7) {
            setOnChanging(true)
            setClickedSubTime('')
            setLoading(true)
            getSubRequestGroup(event.target.value, (isOk, data) => {
                if (!isOk) { setLoading(false); return toast.error(data.message); }
                else {
                    setLoading(false)
                    setOpenSubService(true);
                    setSubRequestGroupData(data);
                }
            })
        }else return window.location.replace("/redirect.html")
    };
    const handleChange1 = (event) => {
        setSubService(event.target.value);
        setOnChanging(true)
        setClickedSubTime('')
    };

    useEffect(() => {
        setLoading(true)
        getRequestGroup((isOk, data) => {
            if (!isOk) { setLoading(false); return toast.error(data.message); }
            else {
                if (data.length === 1) {
                    setHideService(true)
                    setService(data[0].requestGroupId);
                    getSubRequestGroup(data[0].requestGroupId, (isOk, data) => {
                        if (!isOk) { setLoading(false); return toast.error(data.message); }
                        else {
                            setLoading(false)
                            setSubRequestGroupData(data);
                        }
                    })
                } else {
                    setLoading(false)
                    return setRequestGroupData(data);
                }
            }
        })
    }, []);

    useEffect(() => {
        const selectDay = selectedDay.convert(persian, persian_en).format().split('/').join('');
        if (service && subService && selectDay) {
            setLoading(true)
            getReservedTimes(service, subService.subRequestGroupId, selectDay, (isOk, data) => {
                if (!isOk) { setLoading(false); return toast.error(data.message); }
                else {
                    setReservedTimes(data);
                    if (!data.length) {
                        setReservedSubTimes([]);
                        setClickedSubTime('');
                        setOnChanging(false);
                        setLoading(false);
                        return;
                    }
                    getReservedSubTimes(data[0].requestGroupId, data[0].reservationDate, data[0].subRequestGroupId, (isOk, data) => {
                        if (!isOk) { setLoading(false); return toast.error(data.message); }
                        else {
                            setLoading(false)
                            setOnChanging(false)
                            setClickedSubTime('')
                            setReservedSubTimes(data);
                        }
                    })
                }
            })
            setCurrentTime(undefined);
        }
    }, [selectedDay])

    useEffect(() => {
        if (selectedMonth && selectedYear && service && subService) {
            setLoading(true);
            getReservedDays(selectedMonth, selectedYear, service, subService.subRequestGroupId, (isOk, data) => {
                if (!isOk) { setLoading(false); return toast.error(data.message); }
                else {
                    setLoading(false)
                    return setReservedDays(data);
                }
            })
        }
    }, [selectedMonth, selectedYear, service, subService])

    let activeTimes = []
    reservedTimes.map((item) => {
        activeTimes.push(item.startTime.slice(0, 2))
        if (item.startTime.slice(0, 2) !== item.endTime.slice(0, 2)) {
            return activeTimes.push(item.endTime.slice(0, 2))
        }
    })

    const disabledSubTimes = [];

    reservedTimes?.map((item) => {
        const divideHours = Math.floor(getMinutes(item.startTime, item.endTime) / item.patientNumber);
        for (let j = 0; j < item.patientNumber; j += 1) {
            disabledSubTimes.push({
                fullNameGroup: item.fullNameGroup,
                endReservationTime: item.endReservationTime,
                reservationDate: item.reservationDate,
                requestGroupId: item.requestGroupId,
                subRequestGroupId: item.subRequestGroupId,
                reservationDayId: item.reservationDayId,
                time: moment(item.startTime, 'HH:mm').add(divideHours * j, 'minutes').format('HH:mm')
            });
        }
    })

    const nextStep = () => {
        const data = {
            reservationDayId: clickedSubTime.reservationDayId,
            requestGroupId: clickedSubTime.requestGroupId,
            subRequestGroupId: clickedSubTime.subRequestGroupId,
            subTime: clickedSubTime.time,
            reservationDate: clickedSubTime.reservationDate,
            endReservationTime: clickedSubTime.endReservationTime
        }
        setLoading(true)
        addReservedSubTimes(data, (isOk, data) => {
            if (!isOk) {
                setLoading(false)
                return toast.error(data.message);
            } else if (data.length > 0) {
                setLoading(false)
                setToSession("subRequestGroupId", clickedSubTime.subRequestGroupId, 30);
                setToSession("requestGroupId", clickedSubTime.requestGroupId, 30);
                setToSession("price", subService.price, 30);
                setToSession("reservedSubTimesId", data[0].reservedSubTimesId, 30);
                setToSession("service", clickedSubTime.fullNameGroup, 30);
                setToSession("time", clickedSubTime.time || '', 30);
                setToSession("date", selectedDay.convert(persian, persian_en).format(), 30);
                dispatch(updateTab(2));
            }
        })
    }

    return (
        <>
            <div className="booking-calendar-layout">
                <section className="flex-1 md:flex-none">
                    <section className="booking-service-controls">
                        {!hideService && <FormControl className="w-full md:w-[256px]">
                            <Select
                                value={service}
                                onChange={handleChange}
                                displayEmpty
                                style={{fontFamily: 'IRANSansX'}}
                            >
                                <MenuItem value="" style={{fontFamily: 'IRANSansX'}}>
                                    <p>انتخاب درخواست</p>
                                </MenuItem>
                                {requestGroupData.map((item) => (
                                    <MenuItem key={item.requestGroupId} value={item.requestGroupId}
                                              style={{fontFamily: 'IRANSansX'}}>{item.nameGroup}</MenuItem>
                                ))}

                            </Select>
                        </FormControl>}
                        <FormControl className="w-full md:w-[256px]">
                            <Select
                                value={subService}
                                onChange={handleChange1}
                                onClick={() => setOpenSubService(!openSubService)}
                                displayEmpty
                                renderValue={(value) => value ? value.subNameGroup : 'انتخاب خدمت'}
                                open={openSubService}
                                disabled={!service}
                                style={{fontFamily: 'IRANSansX', marginTop: '0.5rem'}}
                            >
                                <MenuItem value="" style={{fontFamily: 'IRANSansX'}}>
                                    <p>انتخاب خدمت</p>
                                </MenuItem>
                                {subRequestGroupData.map((item) => (
                                    <MenuItem key={item.subRequestGroupId} value={item}
                                              style={{fontFamily: 'IRANSansX'}}>{item.subNameGroup}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </section>
                    <section className="flex-1 md:flex-none flex justify-center">
                        <Calendar
                            plugins={[weekends()]}
                            mapDays={({date, today}) => {
                                let props = {}

                                if (reservedDays) {
                                    const q = reservedDays.map((item) => Number(String(item.reservationDate).slice(6)))
                                    let isWeekend;

                                    isWeekend = q.includes(date.day)
                                    if (!isWeekend)
                                        props.disabled = true;
                                    else props.style = {
                                        border: "1px solid #4b9afe"
                                    }
                                }
                                return props
                            }}
                            calendar={persian}
                            locale={persian_fa}
                            value={selectedDay}
                            format="YYYY/MM/DD"
                            minDate={m?.locale('fa')?.format('YYYY/MM/DD')}
                            onChange={(date) => setSelectedDay(date)}
                            disableYearPicker
                            onMonthChange={(date) => {
                                setSelectedMonth(date.month.number);
                                setSelectedYear(date.year)
                            }}
                        />
                    </section>
                </section>
                <section className="booking-times-panel">
                    <p className="booking-notice">* زمان نوبت دهی را با دقت انتخاب کنید پس
                        از زدن دکمه ادامه امکان بازگشت وجود ندارد!</p>
                    {!onChanging && disabledSubTimes.length === 0 && <p className="booking-empty">{!subService ? 'برای مشاهده زمان‌های آزاد، ابتدا خدمت مورد نظر را انتخاب کنید.' : 'برای این تاریخ، زمانی نمایش داده نمی‌شود. تاریخ دیگری را انتخاب کنید.'}</p>}
                    <section className="booking-time-grid">
                        {!onChanging && disabledSubTimes.map((time, index) =>
                            <button type="button" disabled={subTimes.includes(time.time)} aria-pressed={time.time === clickedSubTime.time} onClick={() => {
                                if (!subTimes.includes(time.time)) {
                                    setClickedSubTime(time)
                                }
                            }} key={index}
                                 className={`booking-time ${subTimes.includes(time.time) ? 'is-unavailable' : time.time === clickedSubTime.time ? 'is-selected' : ''}`}>
                                {time.time}
                            </button>
                        )}
                    </section>
                    <div className='flex justify-center'>
                        {currentTime !== undefined && <button type="button" onClick={() => {
                            setCurrentTime(undefined)
                        }}
                                                              className='focus:outline-none text-white w bg-blue-500 hover:bg-blue-600 focus:blue-green-300 mt-8 focus:ring-4 font-medium rounded-lg text-sm px-5 py-2.5'>بازگشت
                            به ساعت ها</button>}
                    </div>
                </section>
            </div>
            <section className="booking-time-legend"><span><i className="booking-legend-dot" />قابل رزرو</span><span><i className="booking-legend-dot unavailable" />رزرو شده</span></section>
            <section className="booking-actions">
                <button disabled={loading || !clickedSubTime} type="button" onClick={() => clickedSubTime && nextStep()}
                        className='focus:outline-none text-white  bg-[#4b9afe] hover:bg-blue-600 focus:ring-blue-300 focus:ring-4 font-medium rounded-lg text-sm px-5 py-2.5 w-[120px] float-left'>ادامه
                </button>
            </section>
            <Backdrop sx={{color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1}} open={loading}>
                <CircularProgress color="inherit"/>
            </Backdrop>
        </>
    )
}
export default PickDate;
